export default __webpack_public_path__ + "static/media/p11.4cb259e2.jpg";